import { AdminFederationsComponent } from './../admin-federations.component';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { OpenDialogAddEditLicenceComponent } from 'app/components/dialog/open-dialog-add-edit-licence/open-dialog-add-edit-licence.component';
import { DatatableBaseComponent } from 'app/shared/components/datatable-base.component';
import { Federation, Licence } from 'app/shared/models/class/federation/federation';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { FederationsService } from 'app/shared/services/federations/federations.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';

@Component({
  selector: 'app-admin-licences',
  templateUrl: './admin-licences.component.html',
  styleUrls: ['./admin-licences.component.scss']
})
export class AdminLicencesComponent extends DatatableBaseComponent implements OnInit {

  clubCode: any;
  title: string;

  @Input() licences: Licence[];
  @Input() federation: Federation;
  dataSource: MatTableDataSource<Licence>;

  displayedColumns = ['label', 'description', 'price', 'actions'];

  isLoading = false;


  length: number;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';

  constructor(
    protected uiSrv: UiService,
    private faIconService: FaiconService,
    private tooltipSrv: TooltipService,
    private federationsSrv: FederationsService,
    private dialog: MatDialog,
    private federationsComponent: AdminFederationsComponent
  ) {
    super(uiSrv);
  }

  ngOnInit(): void {
    this.initTable();
  }

  private initTable(): void {
    if (this.licences) {
      this.dataSource = new MatTableDataSource(this.licences);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.length = this.licences.length;
      this.isLoading = false;
    }

  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  getTooltip(value: string): string {
    return this.tooltipSrv.getTooltip(value);
  }

  openDialogAddEditLicence(actionDialog: string, federation: Federation, licenceUpdate?: Licence): void {

    const dialogRef = this.dialog.open(OpenDialogAddEditLicenceComponent, {
      data: { action: actionDialog, federation: federation, licence: licenceUpdate || null },
      height: '300px',
      width: '600px'
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {res ? this.federationsComponent.getFederations(): null}
    });
  }
}
